import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { collection, getDocs, deleteDoc, doc, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase/config";
import { FiTrash2, FiMail, FiPhone, FiUser } from "react-icons/fi";

const ContactForms = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    setLoading(true);
    try {
      const snap = await getDocs(query(collection(db, "contactSubmissions"), orderBy("createdAt", "desc")));
      setSubmissions(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { fetch(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this submission?")) return;
    await deleteDoc(doc(db, "contactSubmissions", id));
    fetch();
  };

  if (loading) {
    return <AdminLayout><div className="flex justify-center py-20"><div className="w-8 h-8 border-4 border-[#e84fa5] border-t-transparent rounded-full animate-spin" /></div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="max-w-5xl">
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-extrabold text-black">Contact Forms</h1>
            <p className="text-sm text-gray-400">{submissions.length} submission{submissions.length !== 1 ? "s" : ""}</p>
          </div>
          <button onClick={fetch} className="px-4 py-2 border border-gray-300 rounded-lg text-[12px] font-semibold hover:border-[#e84fa5] transition">Refresh</button>
        </div>

        {submissions.length === 0 ? (
          <div className="bg-white rounded-xl border border-gray-100 p-10 text-center text-gray-400 text-[13px]">
            No contact form submissions yet.
          </div>
        ) : (
          <div className="space-y-4">
            {submissions.map((s) => (
              <div key={s.id} className="bg-white rounded-xl border border-gray-100 p-5">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 flex-wrap">
                      <span className="flex items-center gap-1.5 text-[13px] font-bold text-black">
                        <FiUser size={13} /> {s.name}
                      </span>
                      <span className="flex items-center gap-1.5 text-[12px] text-gray-500">
                        <FiMail size={12} /> {s.email}
                      </span>
                      {s.createdAt?.toDate && (
                        <span className="text-[11px] text-gray-400">{s.createdAt.toDate().toLocaleString()}</span>
                      )}
                    </div>
                    {s.subject && <p className="mt-1 text-[12px] text-gray-500 font-semibold">Subject: {s.subject}</p>}
                    {s.message && <p className="mt-2 text-[13px] text-gray-600 leading-relaxed whitespace-pre-wrap">{s.message}</p>}
                  </div>
                  <button onClick={() => handleDelete(s.id)}
                    className="ml-4 p-2 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition shrink-0"
                    title="Delete">
                    <FiTrash2 size={14} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default ContactForms;
